import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material"
import Anchor from "../buttons/Anchor"

const MenuItem = ({open, text, link, children, icon}) => {
  return (
    // <ListItem disablePadding style={{display: "flex", flexDirection: 'column'}}>
    //     <Anchor to={link}>
    //         <ListItemButton>
    //             <ListItemIcon sx={{ minWidth: 0, mr: open ? 3 : 'auto', justifyContent: 'center', }} >
    //                 {icon}
    //             </ListItemIcon>
    //             <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
    //         </ListItemButton>
    //     </Anchor>
    //     <Collapse in={true} timeout="auto" unmountOnExit>
    //         <List component="div" disablePadding>{children}</List>
    //     </Collapse>
    // </ListItem>
    <ListItem key={text} disablePadding sx={{ display: 'block' }}>
    <Anchor to={link}>
        <ListItemButton
        sx={{
            minHeight: 48,
            justifyContent: open ? 'initial' : 'center',
            px: 2.5,
        }}
        >
        <ListItemIcon
            sx={{
            minWidth: 0,
            mr: open ? 3 : 'auto',
            justifyContent: 'center',
            }}
        >
            {icon}
        </ListItemIcon>
        <ListItemText primary={text} sx={{ opacity: open ? 1 : 0 }} />
        </ListItemButton>
    </Anchor>
  </ListItem>
  )
}

export default MenuItem